export default "__VITE_ASSET__Xfu6dl6V__"